import { Helmet } from "react-helmet-async";

// Per-route titles/descriptions. Absolute-URL tags (canonical, og:url) are
// intentionally omitted until a production domain is confirmed.
const Seo = ({ title, description }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
  </Helmet>
);

export default Seo;
